import Dropdown from 'react-bootstrap/Dropdown';
import './DropdownMenu.scoped.scss';
import Button from '../../button/Button';
const DropdownMenu =({filters, handleFilterChange, setFilters}) => {
    const teamOptions = [
        "ARI",
        "ATL",
        "BAL",
        "BUF",
        "CAR",
        "CHI",
        "CIN",
        "CLE",
        "DAL",
        "DEN",
        "DET",
        "GB",
        "HOU",
        "IND",
        "JAX",
        "KC",
        "LV",
        "LAC",
        "LA",
        "MIA",
        "MIN",
        "NE",
        "NO",
        "NYG",
        "NYJ",
        "PHI",
        "PIT",
        "SF",
        "SEA",
        "TB",
        "TEN",
        "WFT"
    ]
    const handleClearTags = () => {
        const newTagFilters = {};
        teamOptions.forEach(tag => {
            newTagFilters[tag] = false;
        });
        setFilters(prev => ({ ...prev, tag: newTagFilters }));
    };
    const handleSelectAllTags = () => {
        const newTagFilters = {};
        teamOptions.forEach(tag => {
            newTagFilters[tag] = true;
        });
        setFilters(prev => ({ ...prev, tag: newTagFilters }));
    };
  return (
    

      <Dropdown.Menu>
        <div className='tiles teams'>
            {/* Tag Filters */}
            <div className="team-wrap">
                {teamOptions.map(tag => (
                    <div className='input-container'>
                        <input
                            className='check-button'
                            type="checkbox" 
                            checked={filters.tag[tag]} 
                            onChange={() => handleFilterChange('tag', tag)} 
                        /> 
                        {/* <span>{tag}</span> */}
                        <div className="check-tile">
                            <label key={tag} className={ "check-tile-label " + ( tag || "") }>{tag}</label>
                        </div>
                    </div> 
                ))}
            </div>
        </div>
        <div className="actions">
            <Button onClick={handleClearTags} buttonType="Primary" buttonStyle="Standard" buttonText="Clear All"></Button>
            <Button onClick={handleSelectAllTags} buttonType="Primary" buttonStyle="Standard" buttonText="Select All"></Button>
        </div>
      </Dropdown.Menu>

  );
}

export default DropdownMenu;
